function About() {
  return (
    <div
      id="about"
      className=" w-[95%] lg:w-4/6 mx-auto min-h-[calc(100vh-3rem-59.23px)] pt-12 lg:pt-24"
    >
      <div className="mb-8">
        <h1 className="font-bold text-2xl lg:text-3xl leading-relaxed mb-4">
          About
        </h1>
        <h2 className="text-xl font-bold leading-relaxed">Ausgangslage</h2>
        <p className="leading-loose">
          Schulen befinden sich im Wandel. Die Digitalisierung bringt neue
          Herausforderungen mit sich und öffnet zugleich Türen zu neuem Lernen.
          Besonders sobald wir uns in die Richtung der Erwachsenenbildung
          hinbewegen, sind Selbstständigkeit, Eigenverantwortung und die
          Fähigkeit zur Zusammenarbeit immer wichtiger kompetenzen.
          Herkömmliche Unterrichtsformen, besonders der Frontalunterricht,
          rücken hierbei immer mehr in den Hintergrund. Moderne Lernformen wie
          Blended Learning unterstützen diesen Wandel und bieten den
          Studierenden die Möglichkeit, aktiv, selbstorganisiert und individuell
          zu lernen. Blended Learning ist eine Mischform von Präsenzunterricht
          und Aufträgen, welche die Lernenden selbstständig und ortsunabhängig
          erarbeiten können.
        </p>
      </div>

      <div className="mb-8">
        <h2 className="text-xl font-bold leading-relaxed">
          Fragestellung und Ziel
        </h2>
        <p className="leading-loose">
          Leider sind viele Schulhäuser eintönig und mit Klassenzimmern für den
          Frontalunterricht konzipiert, was nicht dem Bedarf zukünftiger
          Unterrichtsformen entspricht. Im Rahmen dieser interdisziplinären
          Projektarbeit der Berufsmatura setzen wir uns mit der Frage
          auseinander, wie ein Schulhaus konzipiert sein muss, um solche
          Lernprozesse bestens zu unterstützen. Ziel unseres Projekts ist es,
          ein modernes Schulhaus mit einer groben Innenausstattung als 3D-Modell
          fertigzustellen, welches sich an den jetzigen und zukünftigen Wünschen
          der Berufsmaturitätslernenden orientiert.
        </p>
      </div>
    </div>
  );
}

export default About;
